import { MuiImage } from "@repo/ui";
import contactInfoCheckImage from "@repo/ui/assets/images/logout.jpg";
import { type FC } from "react";

export const LogoutImage: FC = () => {
	return (
		<MuiImage
			src={contactInfoCheckImage}
			sx={{
				position: "absolute",
				zIndex: -1,
				left: "-85px",
				top: "150px",
				width: 675
			}} />
	);
}
